<style xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    .form-control {
        min-width: 147px;
    }
    .title_body {
        padding:0px;
    }
</style>

<template>
    <div>
        <form style="width: 100%" @submit.prevent="submit">
            <CCard>
                <CCardHeader>
                    <CIcon name="cil-justify-center"/> <strong> 결제내역 </strong>
                    <small></small>
                </CCardHeader>
                <CCardBody class="title_body" >
                    <CNavbar light color="light">
                        <CForm inline>
                            <div role="group" class="form-group form-row" style="margin-right: 10px;">
                                <div class="col-sm-9 input-group-sm">
                                    <input id="uid-dq9zl88hwf8" type="date"  class="form-control" v-model="startMonthVal" min="2000-01-02" max="2999-12-31" >
                                </div>
                            </div>
                            <div role="group" class="form-group form-row" style="margin-right: 10px;">
                                <div class="col-sm-9 input-group-sm">
                                    <input id="uid-dq9zl88hwf8" type="date"  class="form-control" v-model="endMonthVal" min="2000-01-02" max="2999-12-31" >
                                </div>
                            </div>
                            <div role="group" class="form-group form-row" style="margin-right: 10px;">
                                <div class="col-sm-9 input-group-sm">
                                    <select id="uid-utosbj1koo2" v-model="payType" class="form-control">
                                        <option value="-1">전체</option>
                                        <option value="1">온라인</option>
                                        <option value="2">오프라인</option>
                                        <!--<option value="3">할인</option>-->
                                    </select>
                                </div>
                            </div>
                            <div role="group" class="form-group form-row">
                                 <div class="col-sm-9 input-group-sm">
                                     <CInput
                                             class="mr-sm-2"
                                             placeholder="이름 또는 진료번호"
                                             size="sm"
                                             v-model="searchVal"
                                             @keyup.enter="searchList"
                                     />
                                 </div>
                             </div>
                            <CButton color="outline-success" size="sm" class="my-2 my-sm-0" type="button" @click="searchList">검색</CButton>
                        </CForm>
                    </CNavbar>
                </CCardBody>
            </CCard>
        </form>
        <CRow>
            <div class="col-sm-12" style="margin-bottom: 10px;">
                <div class="col-sm-0.5">
                    <div class="d-inline-block dropdown">
                        <select id="uid-utosbj1koo"  v-model="selectOption"  @change="selectPerPage" class="form-control">
                            <option value="10" selected>10개씩보기</option>
                            <option value="20">20개씩보기</option>
                            <option value="I50">50개씩보기</option>
                        </select>
                    </div>
                    <div class="bottom_btn_custom" style="float: right;">
                        <CButton label=""
                                 type="button"
                                 style="text-align: right"
                                 class="btn btn-info " @click="goExcelDownload">엑셀 다운로드
                        </CButton>
                    </div>
                </div>
            </div>
        </CRow>
        <CRow>
            <CCol sm="12">
                <div bordered="true" small="true">
                    <div class="position-relative table-responsive">
                        <b-table
                                id = "list-table"
                                :items="newItems"
                                :fields="fields"
                                :per-page="perPage"
                                :current-page="currentPage"
                                striped hover
                                @row-clicked="goChitPage"
                        >
                            <template v-slot:cell(id)="data">
                                <b  class="text-right">{{data.item.payId }}</b>
                            </template>
                            <template v-slot:cell(amount)="data">
                                <div  class="text-right">{{data.item.amount | comma}}</div>
                            </template>
                        </b-table>
                    </div>
                    <!-- <div style="float:right;">총합계 -  결제건수: {{paymentCompCnt}}  / 청구금액: {{payMentAmount | comma}} 원-->
                    <div id="tje5Special">
                        <ul class="cf">
                            <li style="width: 220px;">
                                <p>납부금액: {{payMentAmount | comma}} 원</p>
                            </li>
                            <li>
                                <p>결제건수: {{paymentCompCnt}} 건</p>
                            </li>
                        </ul>
                    </div>
                    <b-pagination
                            :link-gen="linkGen"
                            :number-of-pages="10"
                            use-router
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="list-table"
                    />
                </div>
            </CCol>
        </CRow>
    </div>
</template>
<style>
    .btn-col-margin{
        margin-top: 5px;
        margin-left: 15px;
        margin-right: 10px;
    }
</style>
<script>
    import Vue from 'vue'
    import axios from 'axios'
    import VueMoment from 'vue-moment'

    Vue.use(VueMoment)

    export default {
        name: 'app',
        components: {},
        data: function () {
            /* var vueData = {};
             vueData.mydate = new Date();*/

            return {
                perPage: 10,
                selectOption :10,
                currentPage: 1,
                custId:null,
                newItems: [],
                fields: [
                    {
                        key: 'payId',
                        label: 'No',
                        class:'width_set_no',
                        sortable: true
                    },
                    {
                        key: 'insertTime',
                        label: '일자',
                        class:'width_set_nine',
                        sortable: true
                    },
                    {
                        key: 'custName',
                        label: '이름',
                        class:'width_set_nine',
                        sortable: true
                    },
                    {
                        key: 'registNo',
                        class:'width_set_nine',
                        label: '진료번호',
                        sortable: true
                    },
                    {
                        key: 'payType',
                        label: '납부구분',
                        class:'width_set_nine',
                        sortable: true
                    },
                    {
                        key: 'cardCode',
                        label: '카드사',
                        sortable: true
                    },
                    {
                        key: 'amount',
                        label: '납부금액',
                        class:'width_set_nine',
                        sortable: true
                    },
                    {
                        key: 'payStatus',
                        label: '결제상태',
                        /*  class:'textRight',*/
                        sortable: true
                    },
                    {
                        key: 'approveDate',
                        label: '승인시간',
                        /*  class:'textRight',*/
                        sortable: true
                    },
                    {
                        key: 'userInfo',
                        label: '비고(납부자)',
                        sortable: true
                    },
                    {
                        key: 'buyerTel',
                        label: '결제자',
                        /*class:'textRight',*/
                        sortable: true
                    },
                    {
                        key: 'authNo',
                        label: '승인번호',
                        /*class:'textRight',*/
                        sortable: true
                    }
                ],
                items: null,
                searchVal: null,
                paymentCompCnt:0,
                payMentAmount:0,
                payType:'-1',
                startMonthVal:  this.$moment().add(-30,'d') .format('YYYY-MM-DD'),
                endMonthVal: this.$moment().format('YYYY-MM-DD')
            }
        },
        filters:{
            comma(val){
                return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        },
        computed: {
            rows() {
                return this.newItems.length;
            }
        },
        mounted() {
            this.searchList();

            /*this.newItems.forEach(function(obj){
                if(obj.payType == "S"){
                    obj.payType = "성공";
                } else if(obj.payType == "F") {
                    obj.payType = "실패";
                } else {
                    obj.payType = "대기";
                }
            });*/

        },
        methods: {
            searchList(value){
                const qs = require('querystring');
                const formData = qs.stringify({'searchVal': this.searchVal
                    ,'startMonthVal': this.startMonthVal
                    ,'endMonthVal': this.endMonthVal
                    ,'payType': this.payType
                });

                axios.post('silver/pay/getPayDetailList', formData)
                    .then(res => {
                        this.items = res.data;
                        this.newItems = [];

                        // 입퇴원 상태 변환   ex) O -> 입원
                        for(var i = 0; i < this.items.length; i++){
                            const obj = new Object();

                            obj.payId = this.items[i].payId;
                            obj.custId = this.items[i].custId;
                            obj.transId = this.items[i].transId;
                            obj.insertTime = this.items[i].insertTime.toString().slice(0, 10);
                            obj.custName = this.items[i].custName;
                            obj.registNo = this.items[i].registNo;
                            obj.payStatus = this.items[i].payStatus;
                            obj.cardCode = this.items[i].cardCode;
                            if(this.items[i].payStatus == "S"){
                                obj.payStatus = "결제성공";
                            } else if(this.items[i].payStatus == "F") {
                                obj.payStatus = "결제실패";
                            } else if(this.items[i].payStatus == "N") {
                                obj.payStatus = "결제대기";
                            } else if(this.items[i].payStatus == "C") {
                                obj.payStatus = "결제취소";
                            } else {
                                obj.payStatus =  this.items[i].payStatus;
                            }

                            if(this.items[i].payType == "1"){
                                obj.payType = "온라인";
                            } else if(this.items[i].payType == "2") {
                                if(this.items[i].payMethod == "C"){
                                    obj.payType = "오프라인(카드)";
                                }else if(this.items[i].payMethod == "M"){
                                    obj.payType = "오프라인(현금)";
                                }else if(this.items[i].payMethod == "P"){
                                    obj.payType = "오프라인";
                                }
                            } else if(this.items[i].payType == "3"){
                                obj.payType = "할인";
                            }
                            obj.amount = this.items[i].amount+"원";
                            obj.userInfo = this.items[i].userInfo;
                            obj.buyerTel = this.items[i].buyerTel;
                            obj.authNo = this.items[i].authNo;

                            if(this.items[i].approveDate != null) {
                                obj.approveDate =  this.items[i].approveDate.slice(0,4) +"-"+ this.items[i].approveDate.slice(4, 6)+"-"+this.items[i].approveDate.slice(6,8)+" "+this.items[i].approveTime.slice(0,2)+":"+
                                    this.items[i].approveTime.slice(2,4)+":"+this.items[i].approveTime.slice(4,6);
                            }

                            this.newItems.push(obj);
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
                axios.post('silver/pay/getPayDetailListCnt',formData)
                    .then(res => {
                        this.paymentCompCnt = res.data.paymentCompCnt ,
                            this.payMentAmount = res.data.payMentAmount
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            },
           /* goUpdatePage(record, index , event) {
                if(record.payType === "온라인(카드)") {
                    this.$router.push({name: 'paydetail', params: {payId: record.payId}});
                }else{
                    this.$router.push({name: 'paymanageupdate', params: {custId: record.custId}});
                }

            },*/
            goChitPage(item){
                if(item.payType == '온라인'){
                    const payId = item.payId;
                    this.windowRef = window.open("#/card/cardchit/"+payId, "admininsert", "width=800,height=800,left=200,top=200");
                    this.windowRef.addEventListener('beforeunload', this.closePortal);
                }
            },
            linkGen(pageNum) {
                return pageNum === 1 ? '?' : '?page=${pageNum}';
            }
            , selectPerPage () {
                this.perPage =  this.selectOption;
            },
            comma(val){
                return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            goExcelDownload() {
                const qs = require('querystring');
                const formData = qs.stringify({'searchVal': this.searchVal
                    ,'startMonthVal': this.startMonthVal
                    ,'endMonthVal': this.endMonthVal
                    ,'payType': this.payType
                });

                axios.post('silver/pay/getPayDetailListExcel', formData, {
                    responseType: "blob",
                }).then(res => {
                    try {
                        let blob = new Blob([res.data], { type: res.headers['content-type'] });
                        //let fileName = this.getFileName(res.headers['content-disposition']);
                        let fileName = "결제내역리스트.xlsx";
                        // fileName = decodeURI(fileName); // 파일명 디코딩 (프로젝트에 따라 사용여부 옵션)

                        if (window.navigator.msSaveOrOpenBlob) { // IE 10+
                            window.navigator.msSaveOrOpenBlob(blob, fileName)
                        } else { // not IE
                            let link = document.createElement('a');
                            link.href = window.URL.createObjectURL(blob);
                            link.target = '_self';
                            if (fileName) link.download = fileName;
                            link.click();
                            link.remove();
                        }
                    } catch (e) {
                        console.error(e)
                    }
                }).catch(error => {
                    console.log(error);
                });
            } , getFileName (contentDisposition) {
                let fileName = contentDisposition
                    .split(';')
                    .filter((ele) => {
                        return ele.toLowerCase().indexOf('filename') > -1
                    })
                    .map((ele) => {
                        return ele
                            .replace(/"/g, '')
                            .split('=')[1]
                    });
                return fileName[0] ? fileName[0] : null
            }
        }
    }
</script>